export enum Modulo {
  ADMINISTRADORA = 2,
  CORRETORA = 3,
  VENDAS = 4,
  ANALISE = 5,
}

export const ModuloRota = {
  [Modulo.ADMINISTRADORA]: 'administradora',
  [Modulo.CORRETORA]: 'corretora',
  [Modulo.VENDAS]: 'corretor',
  [Modulo.ANALISE]: 'analista',
};
